import { NbDialogService, NbToastrService } from '@nebular/theme';
import { PagingService } from './../../../../shared/Services/PagingService';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { FormsFieldService } from '../../services/forms-fields.service';
import { GetFieldPropsComponent } from '../../../forms.properties/components/get/get.component';
import { CreateFieldComponent } from '../create/create.component';
import { UpdateFieldComponent } from '../update/update.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'formsfeild-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetFormFieldComponent extends BaseComponent implements OnInit {
  formmasterId: number;
  sectionId: number;
  constructor(
    public route: Router,
    public service: FormsFieldService,
    public paging: PagingService,
    private activated: ActivatedRoute,
    private diag: NbDialogService,
    private toaster: NbToastrService,
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.formmasterId = this.activated.snapshot.params.id;
    this.sectionId = this.activated.snapshot.params.sid;
    this.pagingModel.query.pageSize = 100;

    this.pagingModel.query.searchTerm = 'FormMasterId:' + this.formmasterId + ',SectionId:' + this.sectionId;
    this.loadEntities();
  }

  formsfields(id) {
    this.route.navigate(['admin/dynamicForms/formsfields/' + id]);
  }

  props(typeId, fieldId, formsfieldslist) {
    this.diag
      .open(GetFieldPropsComponent, { context: { typeId: typeId, fieldId: fieldId, item: formsfieldslist } })
      .onClose.subscribe((res) => {
        if (res === 'true') this.ngOnInit();
      });
  }

  addField() {
    this.diag
      .open(CreateFieldComponent, { context: { formMasterId: this.formmasterId, sectionId: this.sectionId } })
      .onClose.subscribe((res) => {
        if (res === 'true') this.ngOnInit();
      });
  }

  update(id) {
    this.diag.open(UpdateFieldComponent, { context: { formFieldId: id } }).onClose.subscribe((res) => {
      if (res === 'true') this.ngOnInit();
    });
  }

  delete(id){
    this.service.delete(id).subscribe(res=> {
      this.toaster.success(`delete field successfully`, 'success', {duration: 4000});
      this.ngOnInit();
    })
  }
}
